import React from "react";
import { Checkbox } from "antd";
import { formatDate } from "../../../services";
import { Separator } from "../ChatsList/Separator";
import styles from "../chatPage.scss";
import sysStyles from "./systemMessages.scss";

const SystemMessageItem = ({ message, onClick, isLastItem, isSelected, onSelect }) => {
  const isUnread = !message.isRead;
  const weightClass = isUnread ? sysStyles.unreadText : sysStyles.readText;

  return (
    <React.Fragment>
      <div className={`${styles.chatsListitem} ${sysStyles.clickableItem}`} onClick={() => onClick(message.id)}>
        <div onClick={(e) => e.stopPropagation()}>
          <Checkbox
            checked={isSelected}
            onChange={(e) => {
              e.stopPropagation();
              onSelect(e.target.checked);
            }}
          />
        </div>
        <div className={styles.chatsListItemWrapper}>
          <div className={`${styles.otherChatParticipantName} ${weightClass}`}>
            {isUnread && <div className={styles.redCircle} />}
            {message.senderName || "Index Oglasi"}
          </div>
          <div className={styles.lastMessage}>
            <span className={weightClass}>
              {message.title}
            </span>
            <span className={styles.lastMessageContent}>
              {message.preview || ""}
            </span>
          </div>
          <div className={styles.timestamp}>
            {formatDate(message.createdAt)}
          </div>
        </div>
      </div>
      {!isLastItem && <Separator />}
    </React.Fragment>
  );
};

export default SystemMessageItem;



// WEBPACK FOOTER //
// ./src/containers/ChatsPage/SystemMessages/SystemMessageItem.tsx